var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "memorandum_info" }, [
    parseInt(this.vacation.id) > 0
      ? _c(
          "div",
          { staticClass: "vacation_data" },
          [
            _c("div", { staticClass: "before_change" }, [
              _c("legend", [_vm._v("Період відпустки")]),
              _vm._v(" "),
              _c("b", [_vm._v("з")]),
              _vm._v(_vm._s(this.vacation.from) + " "),
              _c("b", [_vm._v("по")]),
              _vm._v(" " + _vm._s(this.vacation.to) + "\n        "),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "row mem_create_row pb-5 mb-5" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-5 col-lg-5 col-xl-4 offset-md-7 offset-lg-7 offset-xl-8",
                    attrs: { xs: "6", "offset-xs": "6" },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-lg btn-primary waves-effect waves-themed w-100",
                        attrs: { type: "button" },
                        on: { click: _vm.change_period },
                      },
                      [
                        _c("span", { staticClass: "fal fa-eject mr-1" }),
                        _vm._v(
                          "\n                        Змінити період відпустки\n                    "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("edit_vacation"),
            _vm._v(" "),
            _c("legend"),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }